import { useEffect, type ReactNode } from 'react';
import { realtime } from '@services/realtime';
import { useAuthStore } from '@store/authStore';
import { tokenStorage } from '@services/api';

export function RealtimeProvider({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;
    const url = import.meta.env.VITE_WS_URL;
    if (!url) return;
    const token = tokenStorage.getAccessToken() ?? undefined;
    void realtime.connect(url, token);
    return () => realtime.disconnect();
  }, [isAuthenticated]);

  return <>{children}</>;
}
